module.exports = __webpack_public_path__ + "static/media/sytem-zetonowy-level3-A.c0c1dec5.jpg";